import React from 'react'
import PropTypes from 'prop-types'
require('ta-semantic-ui/semantic/dist/components/item.css')
require('ta-semantic-ui/semantic/dist/components/image.css')
require('ta-semantic-ui/semantic/dist/components/grid.css')
require('ta-semantic-ui/semantic/dist/components/header.css')

/**
 * Render a profile block.
 * @param {string} props.name Name of the person.
 * @param {string} props.avatarSrc Source URL of the avatar image.
 * @param {string} props.children The description of the person. Placed
 * between the <Profile> tages.
 * @returns {XML}
 */
export default function profile (props) {
  return (
    <section className='ui vertical segment basic profile'>
      <div className='ui grid'>

        <div className='ui column row stackable' >
          <div className='person five wide column' style={{ maxWidth: '200px' }}>
            <img
              src={props.avatarSrc}
              alt={`Bild von ${props.name}`}
              className='ui circular fluid image'
            />
            <div className='name'>{props.name}</div>
            <div className='byline'>{props.byline}</div>
          </div>
          <div className='eleven wide column'>
            <div className='description'>{props.children}</div>
          </div>
        </div>

      </div>
    </section>
  )
}

profile.propTypes = {
  children: PropTypes.any,
  name: PropTypes.string.isRequired,
  avatarSrc: PropTypes.string.isRequired,
  byline: PropTypes.string
}
